import Button from 'components/Button';
import Error from 'components/form/Error';
import { FC, useState } from 'react';
import styled from 'styled-components';
import privateAPI from 'utils/privateAxiosInstance';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  p {
    text-align: center;
    margin-bottom: 3rem;
  }
`;

const VerifiedEmailRequired: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [sent, setSent] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const handleClick = () => {
    setLoading(true);
    setSent(false);
    setError(false);

    privateAPI
      .post('/auth/send-verification-email')
      .then(() => {
        setSent(true);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setError(true);
      });
  };
  return (
    <Container>
      <p>Votre adresse email n'a pas encore été vérifiée.</p>
      <Button
        color="primary"
        variant="filled"
        loading={loading}
        onClick={handleClick}
      >
        Envoyer un lien de vérification
      </Button>
      {sent && (
        <span>Un lien de vérification a été envoyé à votre adresse email.</span>
      )}
      {error && <Error>Une erreur est survenue.</Error>}
    </Container>
  );
};

export default VerifiedEmailRequired;
